"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var IconBrengerSmile_1 = require("../icon/IconBrengerSmile");
var Label_1 = require("./Label");
var bcns = function (showBorder) {
    return (0, classnames_1.default)(
    // 'form-select' is from Tailwind CSS Custom Forms (see config for package details)
    'br-form-select', 'focus:br-border-blue-600', 'br-shadow', 'br-rounded-default', {
        'br-border-gray-500': showBorder,
        'br-border-white': !showBorder,
        'br-shadow': !showBorder
    });
};
var colors = {
    blue: 'br-text-blue-600',
    gray: 'br-text-gray-800',
    green: 'br-text-green-400'
};
var colorsDisabled = {
    blue: 'br-text-blue-200',
    gray: 'br-text-gray-500',
    green: 'br-text-green-100'
};
var icns = (0, classnames_1.default)('br-text-blue-600', 'br-absolute', 'br-top-2', 'br-right-3', 'br-pointer-events-none');
var Select = function (_a) {
    var onChange = _a.onChange, _b = _a.showBorder, showBorder = _b === void 0 ? true : _b, labelText = _a.labelText, _c = _a.smileColor, smileColor = _c === void 0 ? 'blue' : _c, className = _a.className, iconClassName = _a.iconClassName, _d = _a.noDefaultClasses, noDefaultClasses = _d === void 0 ? false : _d, // should always be false, this is an exception for the DateTimePeriodSelector component in this repo,
    unused = __rest(_a, ["onChange", "showBorder", "labelText", "smileColor", "className", "iconClassName", "noDefaultClasses"]);
    return (React.createElement(Label_1.Label, { text: labelText },
        React.createElement("div", null,
            React.createElement("label", { className: (0, classnames_1.default)('br-relative') },
                React.createElement("select", __assign({ onChange: function (event) {
                        event.preventDefault();
                        var target = event.target;
                        onChange === null || onChange === void 0 ? void 0 : onChange(target.value);
                    }, className: (0, classnames_1.default)(noDefaultClasses ? undefined : bcns(showBorder), className), style: {
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        appearance: 'none',
                        backgroundImage: 'none'
                    } }, unused)),
                React.createElement(IconBrengerSmile_1.IconBrengerSmile, { className: (0, classnames_1.default)(noDefaultClasses ? undefined : icns, iconClassName, unused.disabled ? colorsDisabled[smileColor] : (0, classnames_1.default)(colors[smileColor])) })))));
};
exports.Select = Select;
